/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function useDurationTranslate() {
  const locale = useLocale()
  // const t2 = useT2({
  //   day: 'diena',
  //   month: 'mėnuo',
  //   year: 'metai',
  //   days: 'dienos',
  //   months: 'mėnesiai',
  //   years: 'metai',
  // })

  // const durationI18nOne = useEnumTranslator(() => ({ Day: t2('day'), Month: t2('month'), Year: t2('year') }))
  // const durationI18nMulti = useEnumTranslator(() => ({ Day: t2('days'), Month: t2('months'), Year: t2('years') }))

  const ttt = {
    day: {
      lt(d: number) {
        if ((d >= 10 && d <= 20) || d % 10 === 0) return `${d} dienų`
        if (d % 10 === 1) return `${d} dieną`
        return `${d} dienos`
      },
      en(d: number) {
        if (d === 1) return `${d} day`
        return `${d} days`
      },
    },
    month: {
      lt(d: number) {
        if ((d >= 10 && d <= 20) || d % 10 === 0) return `${d} mėnesių`
        if (d % 10 === 1) return `${d} mėnesis`
        return `${d} mėnesiai`
      },
      en(d: number) {
        if (d === 1) return `${d} month`
        return `${d} months`
      },
    },
    year: {
      lt(d: number) {
        if ((d >= 10 && d <= 20) || d % 10 === 0) return `${d} metų`
        if (d % 10 === 1) return `${d} metai`
        return `${d} metai`
      },
      en(d: number) {
        if (d === 1) return `${d} year`
        return `${d} years`
      },
    },
  }

  function durationStr(d: gen.DurationFragment | None): string | undefined {
    if (!d) return undefined
    switch (d.unit) {
      case 'Day': return locale.value === 'en' ? ttt.day.en(d.value) : ttt.day.lt(d.value)
      case 'Month': return locale.value === 'en' ? ttt.month.en(d.value) : ttt.month.lt(d.value)
      case 'Year': return locale.value === 'en' ? ttt.year.en(d.value) : ttt.year.lt(d.value)
      default: return helpers.never(d.unit, () => undefined)
    }
  }

  return durationStr
}
